module.exports = __webpack_public_path__ + "static/media/badge-web.fb827e29.png";